module.exports = __webpack_public_path__ + "media/images/icon__settings@2x-f3646c83e7c4cd3000464e147d819661.png";